var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-rel"},[_c('video',{attrs:{"id":"player","width":"100%","height":_vm.isFullView ? 'auto' : 200,"controls":""}},[_c('source',{attrs:{"id":"source","src":_vm.src,"type":"video/mp4"}}),_vm._v("\n\t\tYour browser does not support the video tag.\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }